import cn from 'utils/cn'
import { ReactNode } from 'react'
import { InputRadio } from 'core/components/inputs/Radio'
import { useFormContext } from 'react-hook-form'
import { FundingModalFormValues } from 'core/widgets/funding-modal/FundingModal'
import { fundingModalDefaultCustomAmount } from 'core/widgets/funding-modal/constants'

interface Props {
  label: ReactNode | string
  value: FundingModalFormValues['amountType']
  children?: ReactNode
  className?: string
}

const EditAmountRadio = ({ label, value, children, className }: Props) => {
  const { watch, setValue } = useFormContext<FundingModalFormValues>()
  const [amountType, selectPayPeriodsMode, customAmount] = watch([
    'amountType',
    'selectPayPeriodsMode',
    'customAmount'
  ])

  const disabled = amountType === 'selected-pay-periods' && selectPayPeriodsMode

  return (
    <div className={cn('flex items-center gap-4', className)}>
      <label className="inline w-4 h-4" htmlFor={value}>
        <InputRadio
          id={value}
          checked={amountType === value}
          value={value}
          onChange={() => {
            setValue('amountType', value)
            if (
              amountType === 'other-amount' &&
              value !== 'other-amount' &&
              customAmount === fundingModalDefaultCustomAmount
            ) {
              setValue('enterAmountMode', false)
            }
          }}
          disabled={disabled}
        />
      </label>
      {typeof label === 'string' ? (
        <label htmlFor={value} className="cursor-pointer font-semibold">
          {label}
        </label>
      ) : (
        label
      )}
      {children}
    </div>
  )
}

export default EditAmountRadio
